import { useSelector } from 'react-redux'
import { Icon } from '@calendly/ui/components/icon'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import { currentUserLocaleSelector } from 'selectors/user'

import { MenuButtonContainer, Burger, Cross } from './styles'
import _StyledIcon from "menu_button-StyledIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/dropdown/menu_button.js?styleId=StyledIcon";


const StyledIcon = /*#__PURE__*/styled(Icon, null, {
  displayName: "StyledIcon",
  styles: _StyledIcon
})

const MobileButton = ({ isExpanded }) => {
  const { i18n } = useI18n()
  const locale = useSelector(currentUserLocaleSelector)
  const label = i18n.t('publisher.diagnostics.publisher_toolbar.menu', { locale })

  return (
    isExpanded ? <Cross aria-label={label} /> : <Burger aria-label={label} />
  )
}

const DesktopButton = ({ isExpanded }) => {
  const { i18n } = useI18n()
  const locale = useSelector(currentUserLocaleSelector)
  return (
    <>
      <Burger />
      {i18n.t('publisher.diagnostics.publisher_toolbar.menu', { locale })}
      <StyledIcon name={isExpanded ? 'arrow-up-fill' : 'arrow-down-fill'} />
    </>
  )
}

export const MenuButton = ({ toggleDropdown, isExpanded }) => {
  const isTabletUp = useDeviceType('isTabletUp')

  return (
    <MenuButtonContainer aria-expanded={isExpanded} onClick={toggleDropdown}>
      {
        isTabletUp
          ? <DesktopButton isExpanded={isExpanded} />
          : <MobileButton isExpanded={isExpanded} />
      }
    </MenuButtonContainer>
  )
}
